import { HierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import { withForm, getIn, SidePageV2 } from '@gogame/form';

import { loadStats } from 'scenes/SpendAdjustments/sources/fields';

import Stats from './Stats';
import Targeting from './Targeting';
import {
  STATS,
  DEPENDENCIES,
  TYPE_BY_REGS,
  TYPE,
  TYPE_COST_ADJUSTMENT,
} from './constants';
import { validationSchema, spendAdjustmentsSchema } from './schemas';

const SpendAdjustmentsForm = withForm({
  validationSchema: validationSchema,
})(({
  onClose,
  values,
  loading,
  hierarchyState,
  onExited,
  open,
  submitForm,
  children,
  ...props
}) => {
  const isEditing = !!values.id;
  const isSpendTypeByRegs = values[TYPE] === TYPE_BY_REGS;
  const isCostAdjustment = values[TYPE] === TYPE_COST_ADJUSTMENT;
  const statsLoading = getIn(hierarchyState, `${STATS}.loading`) || false;

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title
        title={props.title}
        subTitle={props.name}
        entityId={props.entityId}
      />
      <SidePageV2.NewBody>
        <Targeting isEditing={isEditing} values={values} />
        <HierarchyArea
          name={STATS}
          active={spendAdjustmentsSchema.isValidSync(values)}
          depends={DEPENDENCIES[STATS]}
          source={loadStats}
        >
          {({ area }) => {
            const { error, data, active, loading } = area;
            return active ? (
              <Stats
                error={error}
                loading={loading}
                stats={data}
                isEditing={isEditing}
                isSpendTypeByRegs={isSpendTypeByRegs}
                isCostAdjustment={isCostAdjustment}
              />
            ) : null;
          }}
        </HierarchyArea>
        {children}
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton disabled={statsLoading} />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default SpendAdjustmentsForm;
